import { Badge, Box, Button, Icon, VStack } from "@chakra-ui/react";
import { useState } from "react";
import { FiChevronDown, FiEdit2, FiRefreshCw } from "react-icons/fi";

interface BulkActionsMenuProps {
  selectedCount: number;
  onBulkEdit?: () => void;
  onBulkPause?: () => void;
}

export function BulkActionsMenu({
  selectedCount,
  onBulkEdit,
  onBulkPause
}: BulkActionsMenuProps) {
  const [showMenu, setShowMenu] = useState(false);

  if (selectedCount <= 1) return null;

  return (
    <>
      <Badge colorScheme="blue" px={3} py={2} rounded="full" fontSize="sm">
        {selectedCount} selected
      </Badge>
      <Box position="relative">
        <Button
          variant="outline"
          size="lg"
          onClick={() => setShowMenu(!showMenu)}
        >
          Bulk Actions <Icon as={FiChevronDown} ml={2} />
        </Button>
        {showMenu && (
          <Box
            position="absolute"
            top="100%"
            right={0}
            mt={2}
            bg="white"
            border="1px"
            borderColor="gray.200"
            rounded="md"
            shadow="lg"
            minW="200px"
            zIndex={10}
          >
            <VStack align="stretch" p={1}>
              <Button
                variant="ghost"
                size="md"
                w="full"
                justifyContent="flex-start"
                onClick={() => {
                  setShowMenu(false);
                  onBulkEdit?.();
                }}
              >
                <Icon as={FiEdit2} mr={2} /> Bulk Edit
              </Button>
              <Button
                variant="ghost"
                size="md"
                w="full"
                justifyContent="flex-start"
                onClick={() => {
                  setShowMenu(false);
                  onBulkPause?.();
                }}
              >
                <Icon as={FiRefreshCw} mr={2} /> Bulk Pause
              </Button>
            </VStack>
          </Box>
        )}
      </Box>
    </>
  );
}
